import {FUIFormContext} from "./form-context";
import {Injectable} from "@angular/core";
import {FUIContextType} from "./form-context-type";

/**
 * Context for controls being used in an inline action mode such as grid selector.
 */
@Injectable()
export class FUIInlineActionFormContext extends FUIFormContext {
    constructor() {
        super(FUIContextType.INLINE_ACTION, "InlineAction");
    }
}
